module.exports = __webpack_public_path__ + "static/media/dress-code-men1.c616e235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code-men1.jpg
// module id = 700
// module chunks = 0